export const statusStyle = {
  pending: { color: '#0491e1', bg: 'rgba(4,145,225,0.12)' },
  bid_sent: { color: '#8b5cf6', bg: 'rgba(139,92,246,0.12)' },

  assigned: { color: '#8b5cf6', bg: 'rgba(139,92,246,0.12)' },
  in_progress: { color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
  completed: { color: '#10b981', bg: 'rgba(16,185,129,0.12)' },
  raise_dispute: { color: '#f97316', bg: 'rgba(249,115,22,0.12)' },
  cancelled: { color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
};

export const statusLabels = {
  pending: "Pending",
  bid_sent: "Bid Sent",

  assigned: "Assigned",
  in_progress: "In Progress",
  awaiting_confirmation: "Awaiting",
  raise_dispute: "Dispute",
  completed: "Completed",
  cancelled: "Cancelled"
};

export const TABS = ['All', 'pending', 'bid_sent',  'assigned', 'in_progress', 'awaiting_confirmation', 'raise_dispute', 'completed', 'cancelled'];

export const DISPUTE_CATEGORIES = [
  'Payment Issue',
  'Work Not Completed',
  'Poor Quality Work',
  'Worker Did Not Show Up',
  'Overcharged',
  'Damaged Property',
  'Other',
];